import { WaypointDirectionModel } from "./WaypointDirection.model";

export class WaypointDirection extends WaypointDirectionModel {
    // Add custom methods here
}
